export default __webpack_public_path__ + "static/media/linkedin.f955aa65.svg";